import { MdWifiOff, MdSync } from 'react-icons/md';
import { useOnlineStatus } from 'hooks/useOnlineStatus';
import { useEffect, useState } from 'react';
import { offlineDb } from 'utils/offlineDb';

/**
 * Floating banner displayed at the bottom of the screen when the user
 * is offline. Also shows the number of changes pending synchronization.
 */
const OfflineBanner = () => {
    const isOnline = useOnlineStatus();
    const [pendingCount, setPendingCount] = useState<number>(0);

    useEffect(() => {
        if (isOnline) {
            setPendingCount(0);
            return;
        }
        // Recount pending mutations each time the app goes offline
        offlineDb.getPendingMutations().then((m) => setPendingCount(m.length));
    }, [isOnline]);

    if (isOnline) return null;

    return (
        <div className="fixed bottom-5 left-1/2 z-[9999] flex -translate-x-1/2 items-center gap-2 rounded-full bg-orange-500 px-5 py-2.5 text-sm font-semibold text-white shadow-xl">
            <MdWifiOff className="text-xl" />
            <span>Offline mode</span>
            {pendingCount > 0 && (
                <span className="flex items-center gap-1 rounded-full bg-white/20 px-2 py-0.5 text-xs">
                    <MdSync className="animate-spin" />
                    {pendingCount} en attente
                </span>
            )}
        </div>
    );
};

export default OfflineBanner;
